define('app/sds/report/requested/view/sds-report-requested-view',["service!selcomm", "$q", "service!selcomm:filter"], function (SelcommWS, $q, filter) {
	"use strict";
	return {
		controller: {
			bind: {
				"reportId": "="
			},
			prototype: {
				demoFixStyle: function ($elements) {
					var stylesheetElements = $('html > head link[rel="stylesheet"]').clone();
					$elements.head.append(stylesheetElements);
					$('table', $elements.body).addClass("table table-bordered table-striped");
					$elements.head.append('<style>tr:nth-child(4), tr:nth-child(5){ display: none; }tr:nth-child(1) > td:empty, tr:nth-child(2) > td:empty, tr:nth-child(3) > td:empty, tr:last-child > td:empty{ border-left: 0px none transparent; border-right: 0px none transparent; }</style>');
				},
				loadNumber: 20,
				RequestedReportList: SelcommWS.prepare.post("Reports", "RequestedReportList"),
				ReportRequestedDownload: SelcommWS.prepare.get("Reports", "ReportRequestedDownload"),
				loadRequestedReportFile: function loadRequestedReportFile(requestId, reportOutputFileType) {
					reportOutputFileType = reportOutputFileType || "HTML";
					return this.ReportRequestedDownload({
						RequestId: requestId,
						ReportOutputFileType: reportOutputFileType,
						TestMode: true
					}).then(function (reportFile) {
						reportFile.Content.mimeType = (function () {
							switch (reportOutputFileType) {
								case 0: case "PDF":
									return "application/pdf";
								case 1: case "XLSX":
									return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
								case 2: case "HTML":
									return "text/html";
								case 3: case "PNG":
									return "image/png";
								case 4: case "CSV":
									return "text/csv";
								case 5: case "WORD":
									return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
							}
						}());
						reportFile.Content.$value = (function (mimeType, value) {
							switch (mimeType) {
								case "application/pdf":
								case "text/csv":
								case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
								case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
								case "image/png":
									return "data:" + mimeType + ";base64," + value;
								case "text/csv":
								case "text/html":
									return atob(value);
							}
						}(reportFile.Content.mimeType, reportFile.Content.$value));
						return reportFile;
					});
				},
				loadRequestedReports: function loadRequestedReports() {
					var vm = this;
					return $q(function ($return, $throw) {
						var fltr = filter.all(
									filter.compare("Report.ReportId", "=", vm.reportId), 
									filter.compare("StatusCode", "=", "C"),
									filter.compare("Deleted", "=", false));
						vm.RequestedReportList({
							PagingSortsAndFilters: {
								SkipRecords: vm.reports && vm.reports.length || 0,
								TakeRecords: vm.loadNumber,
								Filter: fltr,
								Sorts: [{
									TargetProperty: "StartDateTime",
									Direction: "Descending"
								}]
							}
						}).then(function (data) {
							var reports = vm.reports = vm.reports || [];
							// Splice in the new reports.
							Array.prototype.splice.apply(reports, [reports.length, 0].concat(angular.map(data.Items || data, function (requestedReport) {
								var _reportFile;
								Object.defineProperties(requestedReport, {
									reportFile: {
										get: function file_get() {
											if (!_reportFile) {
												_reportFile = {
													loading: vm.loadRequestedReportFile(this.RequestId).then(function (reportFile) {
														_reportFile = reportFile;
													})
												};
											}
											return _reportFile;
										}
									}
								});
								return requestedReport;
							})));
							$return(data);
						}).catch(function (err) {
							$throw(err);
						});
					});
				},
				selectedIndex: 0,
				previousReport: function previousReport() {
					if (this.selectedIndex + 1 < this.reports.length) {
						this.selectedIndex++;
					}
				},
				nextReport: function nextReport() {
					if (this.selectedIndex > 0) {
						this.selectedIndex--;
					}
				}
			},
			properties: {
				selectedReport: function selectedReport_get() {
					return this.reports && this.reports[this.selectedIndex];
				}
			},
			constructor: ["$self", function (vm) {
				var result = vm.loadRequestedReports().then(function (reports) {

				});
			}]
		}
	};
});
